import React, { Fragment, ReactNode } from 'react';
import cx from 'classnames';

import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
} from '@/src/components/ui/carousel';
import {
  IResolvedCardItem,
  IResolvedCardLayout,
} from '@/src/utils/collections/cards.mapper';
import { CardThreeColumnsItem } from '@/src/components/cards/CardThreeColumns/CardThreeColumnsItem';
import { CardVideoItem } from '@/src/components/cards/CardVideoItem/CardVideoItem';
import { ILocaleType } from '@/src/types';
import { CardAction } from '@/src/components/cards/CardAction/CardAction';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';

interface IProps {
  title: ReactNode;
  text: ReactNode;
  items: IResolvedCardItem[];
  action: Extract<IResolvedCardLayout, { type: 'three' }>['data']['action'];
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  locale: ILocaleType;
}

export const CardThreeColumns = ({
  items,
  action,
  locale,
  destinations,
}: IProps) => {
  const isVideoType = items.some(item => item.media.type === 'video');

  return (
    <div className={`mx-auto max-w-1200`}>
      <div
        className={cx(
          !isVideoType ? 'hidden grid-cols-3' : 'grid-cols-1 lg:grid-cols-3',
          'gap-10 lg:grid lg:px-4'
        )}
      >
        {items.map((item, index) => (
          <Fragment key={item.title + '_' + index}>
            {item.media.type !== 'video' && <CardThreeColumnsItem {...item} />}
            {item.media.type === 'video' && (
              <CardVideoItem
                title={item.title}
                content={item.content}
                mediaWidth={item.mediaWidth}
                media={item.media}
              />
            )}
          </Fragment>
        ))}
      </div>
      {!isVideoType && (
        <Carousel
          opts={{
            align: 'center',
          }}
          className="w-full lg:hidden"
        >
          <CarouselContent className={'ml-4 mr-8'}>
            {items.map((item, index) => (
              <CarouselItem
                key={item.title + '_' + index + 'carousel'}
                className={'flex basis-10/12 pl-8 first:pl-0'}
              >
                <CardThreeColumnsItem {...item} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselDots className={'mt-8'} />
        </Carousel>
      )}
      {action?.type !== 'none' && (
        <div className={'mt-10 flex w-full justify-center'}>
          <CardAction
            destinations={destinations}
            action={action}
            locale={locale}
          />
        </div>
      )}
    </div>
  );
};
